const BASEURL = process.env.VUE_APP_SERVER_URL
const TOKEN = localStorage.getItem('access_token')
const fetchInventoryData = async (model) => {
  let resp = await fetch(`${BASEURL}/api/inventory/${model}`, {
    method: 'GET',
    mode: 'cors',
    headers: {
      'content-type': 'application/json',
      'Authorization': `Bearer ${TOKEN}`,
    },
  })
  let data = await resp.json()
  return data
}

// eslint-disable-next-line no-unused-vars
const patchInventoryData = async (model, id, data) => {
  let resp = await fetch(`${BASEURL}/api/inventory/${model}/${id}`, {
    method: 'PATCH',
    mode: 'cors',
    headers: {
      'content-type': 'application/json',
      'Authorization': `Bearer ${TOKEN}`,
    },
    body: JSON.stringify(data),
  })
  return resp.status
}

const getDepartments = async () => {
  // FAKE DATA
  const departmentdata = [
    { id: 1, name: 'Science' },
    { id: 2, name: 'Psychology' },
    { id: 3, name: 'Arts' },
    { id: 4, name: 'Fine Arts' },
    { id: 5, name: 'Language' },
  ]
  return new Promise((resolve, reject) => {
    resolve(departmentdata)
  })
}

const getSuppliers = async () => {
  // FAKE DATA
  const supplierdata = [
    { id: 1, name: 'MS Big Supplier' },
    { id: 2, name: 'Random Shop' },
    { id: 3, name: 'Happy Shop' },
    { id: 4, name: 'Test Mall' },
    { id: 5, name: 'Pet n Tap' },
  ]
  return new Promise((resolve, reject) => {
    resolve(supplierdata)
  })
}

export const downloadBill = (http, orderId, studentCode, orderNo) => {
  // Make a GET request to your API endpoint that serves the PDF.
  http.get('/api/inventory/order/bill/download?order_id=' + orderId, { responseType: 'blob' })
    .then((response) => {
      // Create a Blob from the response data and create a download link.
      const blob = new Blob([response.data], { type: 'application/pdf' })
      const url = window.URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url
      a.download = 'bill_' + orderNo + '_' + studentCode + '_.pdf' // Specify the file name here
      a.click()
      // window.URL.revokeObjectURL(url)
      /* const pdfWindow = window.open(url, '_blank')
      pdfWindow.print() */

      const pdfWindowPopUp = window.open(url, 'PDF_Popup', 'width=1000,height=800')
      if (!pdfWindowPopUp) {
        alert('Please enable pop-ups for this website to open the PDF in a pop-up window.')
      }
      // pdfWindowPopUp.print()
      window.URL.revokeObjectURL(url)
    })
    .catch((error) => {
      console.error('Error downloading PDF: ', error)
    })
}

export { BASEURL, fetchInventoryData, getDepartments, getSuppliers }
